// import get from 'lodash/get';
// import isNaN from 'lodash/isNaN';

/**
 * format price to same layout
 * @param {String||Number} amount,
 * @param {Number} decimalCount,
 * @param {String} currencyCode,
 * @param {String} decimal,
 * @param {String} thousands,
 */


// eslint-disable-next-line no-unused-vars
const moneyFormatter = function (amount, currencyCode = 'USD', decimalCount = 2, decimal = '.', thousands = ',') {
  // console.log('moneyFormatter', amount, decimalCount, currencyCode);
  if (typeof currencyCode !== 'string') {
    currencyCode = 'USD';
    console.error('moneyFormatter currency code is wrong:', amount, decimalCount, currencyCode);
  }

  currencyCode = currencyCode.toUpperCase();

  decimalCount = Math.abs(decimalCount);
  decimalCount = Number.isNaN(decimalCount) ? 2 : decimalCount;
  const negativeSign = amount < 0 ? '-' : '';
  const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount), 10).toString();
  const j = (i.length > 3) ? i.length % 3 : 0;

  const currencySymbol = {
    'USD': 'US$',
    'JPY': '¥',
    'KRW': '₩',
    'TWD': 'NT$',
    'THB': '฿',
    'EUR': '€',
    'AUD': 'A$',
    'SGD': '$',
  };

  const displaySymbol = currencySymbol[currencyCode];
  const displayMoney = negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '');

  return `${displaySymbol} ${displayMoney}`;
};

module.exports = {
  moneyFormatter: moneyFormatter,
};
